import { getElementSize as fn } from '##/hooks/useResizeObserved/getElementSize';

/**
 * @deprecated use import { getElementSize } from '@consta/uikit/useResizeObserved'
 */
export const getElementSize = fn;
